import { getApiConfig } from "helpers/authHelper"
import { get, post, put, del } from "../apiHelper"
import * as url from "../urlHelper"

export const getAllTrainingQuestions = () => {
  return get(url.TRAINING_QUE, getApiConfig())
}

export const createTrainingQuestions = data => {
  return post(url.TRAINING_QUE, data, getApiConfig(true))
}

export const updateTrainingQuestions = (id,data) => {
  return put(`${url.TRAINING_QUE}/${id}`, data, getApiConfig())
}

export const deleteTrainingQuestions = id => {
  return del(`${url.TRAINING_QUE}/${id}`, getApiConfig())
}

export const getTrainingQuestions = id => {
  return get(`${url.TRAINING_QUE}/${id}`, getApiConfig())
}
